import { createContext } from 'react';

import type { ProductCouponProps } from '@/domains/loyalty/components/Coupon/Coupon';

export type CouponContextType = Partial<
  Omit<ProductCouponProps, 'isBulkPurchaseCoupon' | 'context'>
> &
  Pick<ProductCouponProps, 'context'>;

export const CouponContext = createContext<CouponContextType>({
  context: '',
});

CouponContext.displayName = 'CouponContext';
